import { SYMBOL_BY_CODE } from "@/data/dentalCases";

export const SymbolChip = ({ code, big = false }) => {
  const s = SYMBOL_BY_CODE[code];
  if (!s) return null;
  return (
    <span
      className="inline-flex items-center justify-center rounded font-bold text-white leading-none"
      style={{
        background: s.color,
        fontSize: big ? 11 : 9,
        padding: big ? "2px 5px" : "1px 3px",
      }}
    >
      {code}
    </span>
  );
};
